import axios from 'axios';
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const api = axios.create({
    baseURL: `${API_URL}/api`,
    headers: {
        'Content-Type': 'application/json'
    }
});
// Add token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
// Auth APIs
export const authAPI = {
    signup: (username, email, password) => api.post('/auth/signup', { username, email, password }),
    login: (username, password) => api.post('/auth/login', { username, password }),
    getProfile: () => api.get('/auth/profile')
};
// Card APIs
export const cardAPI = {
    getAllCards: () => api.get('/cards'),
    getUserCards: () => api.get('/cards/my-cards'),
    drawCard: () => api.post('/cards/draw', {}),
    getAttributeAdvantages: () => api.get('/cards/attribute-advantages'),
    getTeams: () => api.get('/teams'),
    createTeam: (name, card_slots) => api.post('/teams', { name, card_slots }),
    updateTeam: (teamId, data) => api.put(`/teams/${teamId}`, data),
    deleteTeam: (teamId) => api.delete(`/teams/${teamId}`),
    autoCreateTeam: (teamName = '自動隊伍') => api.post('/teams/auto/create', { teamName }),
    getAutoTeamSuggestion: () => api.get('/teams/auto/suggestion')
};
// Battle APIs
export const battleAPI = {
    startBattle: (teamId, isPvP = false, opponentId) => api.post('/battles/start', { teamId, isPvP, opponentId }),
    executeRound: (battleState, playerAttackIndex, playerDefenseIndex, opponentAttackIndex, opponentDefenseIndex) => api.post('/battles/round', { battleState, playerAttackIndex, playerDefenseIndex, opponentAttackIndex, opponentDefenseIndex }),
    finishBattle: (opponentId, winner, battleLog, rewards) => api.post('/battles/finish', { opponentId, winner, battleLog, rewards }),
    getBattleHistory: (limit = 20) => api.get(`/battles/history?limit=${limit}`),
    getDailyDraws: () => api.get('/battles/daily-draws')
};
// Admin APIs
export const adminAPI = {
    login: (password) => api.post('/admin/login', { password }),
    getAllUsers: () => api.get('/admin/users'),
    getUserData: (userId) => api.get(`/admin/users/${userId}`),
    modifyUserData: (userId, data) => api.put(`/admin/users/${userId}`, data),
    createAnnouncement: (title, content, expiresAt) => api.post('/admin/announcements', { title, content, expiresAt }),
    getAnnouncements: () => api.get('/admin/announcements'),
    deleteAnnouncement: (announcementId) => api.delete(`/admin/announcements/${announcementId}`),
    getGameStats: () => api.get('/admin/stats')
};
export default api;
